import { render, staticRenderFns } from "./CustomerChart.vue?vue&type=template&id=3363d6f7&"
import script from "./CustomerChart.vue?vue&type=script&lang=js&"
export * from "./CustomerChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports